import { Link } from 'react-router-dom';
import { collection } from '@/mocks/home';
import { cdn } from '@/config/cdn';
import PhotoMotion from '@/components/feature/PhotoMotion';

type Item = (typeof collection)[number];

function Caption({ item, index }: { item: Item; index: number }) {
  return (
    <div className="mt-5 grid grid-cols-[28px_minmax(0,1fr)_auto] gap-x-4 items-baseline md:min-h-[104px] content-start">
      <span className="fold-label text-[#8A8580]">0{index + 1}</span>
      <h3 className="fold-serif text-xl md:text-[26px] leading-tight">{item.name}</h3>
      <span className="text-sm tabular-nums">{item.price}</span>
      <p className="col-start-2 col-span-2 mt-2 text-sm leading-relaxed text-[#5d5853] max-w-[400px]">{item.note}</p>
    </div>
  );
}

type Motion = { delay?: number; fromScale?: number; fromY?: number; parallax?: number };

function Feature({ item, index, ratio, className, motion }: { item: Item; index: number; ratio: string; className: string; motion: Motion }) {
  return (
    <article className={`group min-w-0 ${className}`}>
      <Link to="/collection" className="block cursor-pointer" aria-label={`${item.name} — view in the collection`}>
        <div className={`w-full ${ratio} overflow-hidden bg-[#ebe5dc]`}>
          <PhotoMotion {...motion}>
            <img src={cdn(item.src)} alt={item.name} title={`${item.name} — FOLD. ${item.category.toLowerCase()}`} className="fold-img-hover w-full h-full object-cover object-top" />
          </PhotoMotion>
        </div>
        <Caption item={item} index={index} />
      </Link>
    </article>
  );
}

export default function Collection() {
  const [a, b, c] = collection;
  return (
    <section className="bg-[#F5F1EB] py-24 md:py-40" aria-labelledby="collection-title">
      <div className="fold-shell">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-6 gap-y-14">
          <Feature item={a} index={0} ratio="aspect-[4/5]" className="md:col-span-7" motion={{ fromScale: 1.055, fromY: 24, parallax: 18 }} />

          <div className="md:col-span-4 md:col-start-9 flex flex-col justify-between gap-14 min-w-0">
            <div>
              <p className="fold-label text-[#8A8580]">The Collection</p>
              <h2 id="collection-title" className="fold-serif mt-6 text-4xl md:text-[52px] leading-[1.02]">
                A short list, baked to one standard.
              </h2>
              <Link to="/collection" className="mt-8 inline-block fold-label fold-link whitespace-nowrap cursor-pointer">
                View the full range
              </Link>
            </div>
            <Feature item={b} index={1} ratio="aspect-[4/5]" className="" motion={{ delay: 0.12, fromScale: 1.045, fromY: 18 }} />
          </div>

          <Feature item={c} index={2} ratio="aspect-[16/9]" className="md:col-span-10 md:col-start-3 md:mt-16" motion={{ fromScale: 1.05, fromY: 22, parallax: 20 }} />
        </div>
      </div>
    </section>
  );
}